import { useEffect, useState } from 'react';

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <footer id="contact" className="bg-[#efe6d6] pt-12 text-[#4b443c]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:grid-cols-4 md:px-6">
        <div className="md:col-span-1">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#e85d3f] text-lg font-bold text-white">55</span>
            <span className="font-serif-sc text-xl font-black text-[#26201a]">
              吃瓜<span className="text-[#e85d3f]">·追更站</span>
            </span>
          </a>
          <p className="mt-4 max-w-xs text-sm leading-6 text-[#6f655a]">
            连续剧追更资讯门户。今晚最新剧情、追更日历、热播榜单与剧情速递，一站掌握，追更不迷路。
          </p>
        </div>

        <div>
          <h4 className="mb-4 font-serif-sc text-sm font-black text-[#26201a]">快速导航</h4>
          <ul className="space-y-2.5 text-sm">
            {[
              ['今晚抢先看', '#tonight'],
              ['追更日历', '#calendar'],
              ['剧集分类', '#genres'],
              ['热播榜单', '#rank'],
            ].map(([label, href]) => (
              <li key={href}>
                <a href={href} className="transition-colors hover:text-[#e85d3f]">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-serif-sc text-sm font-black text-[#26201a]">追更服务</h4>
          <ul className="space-y-2.5 text-sm">
            {[
              ['剧情速递', '#news'],
              ['追更指南', '#guide'],
              ['常见问题', '#faq'],
              ['订阅速报', '#subscribe'],
            ].map(([label, href]) => (
              <li key={href}>
                <a href={href} className="transition-colors hover:text-[#e85d3f]">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-serif-sc text-sm font-black text-[#26201a]">联系我们</h4>
          <ul className="space-y-2.5 text-sm text-[#6f655a]">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-[#e85d3f]"></i>
              <a href="mailto:hello@55chigua.top" className="transition-colors hover:text-[#e85d3f]">
                hello@55chigua.top
              </a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-[#e85d3f]"></i>
              每日更新动态 · 晚间刷新
            </li>
          </ul>
          <div className="mt-4 flex items-center gap-2">
            {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-mail-line'].map((i) => (
              <a
                key={i}
                href="#contact"
                aria-label="社交平台"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#6f655a] transition-colors hover:bg-[#e85d3f] hover:text-white"
              >
                <i className={i}></i>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-10 border-t border-[#26201a]/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-5 text-xs text-[#8a7f72] sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 55吃瓜·追更站 版权所有 · 本站为追更与导览资讯站，不提供影视正片资源。</p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#about" className="hover:text-[#e85d3f]">关于本站</a>
            <a href="#faq" className="hover:text-[#e85d3f]">免责声明</a>
            <a href="#contact" className="hover:text-[#e85d3f]">隐私说明</a>
          </div>
        </div>
      </div>

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-[#26201a] text-white shadow-md transition-all hover:bg-[#e85d3f] ${
          showTop ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </footer>
  );
}